<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn id="aviso.voltar" color="primary" x-small text :to="{ name: 'avisos.index' }">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aviso
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12" md="7">
            <v-card outlined class="fill-height">
              <v-card-title class="text-subtitle-1">Destinatários</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="7">
                    <v-select
                      id="form.selected"
                      v-model="form.selected"
                      :items="selects"
                      :disabled="editing"
                      label="Selecione um tipo"
                      outlined
                      dense
                      hide-details
                    >
                      <template #item="{ item, on, attrs }">
                        <v-list-item
                          v-bind="attrs"
                          v-on="on"
                          :id="`form.selected-item-${item.toLowerCase()}`"
                        >
                          <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="5" class="d-flex align-center">
                    <v-checkbox
                      id="form.selectAll"
                      v-if="form.selected && form.selected !== 'Alunos'"
                      v-model="selectAll"
                      label="Selecionar Todos"
                      color="success"
                      class="mt-0 pt-0"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      :name="form.selected || 'destinatários'"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        id="form.items"
                        v-model="form.items"
                        :items="items"
                        :label="form.selected || 'Destinatários'"
                        :error-messages="errors"
                        item-text="descricao"
                        item-value="id"
                        color="blue-grey lighten-2"
                        multiple
                        chips
                        filled
                        dense
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            small
                            @click="data.select"
                            @click:close="remove(data.item)"
                          >
                            <v-avatar color="primary" left>
                              <span class="white--text">{{ iniciais(data.item, 1) }}</span>
                            </v-avatar>
                            {{ data.item.descricao }}
                          </v-chip>
                        </template>

                        <template v-slot:item="{ item }">
                          <v-list-item-avatar color="primary">
                            <span class="white--text">{{ iniciais(item, 3) }}</span>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                            <v-list-item-subtitle v-if="item.turno">
                              {{ item.turno.descricao }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="5">
            <v-card outlined class="fill-height">
              <v-card-title class="text-subtitle-1">
                Imagem
                <v-spacer></v-spacer>
                <v-btn
                  id="aviso.deletar-imagem"
                  v-if="temImagem"
                  color="red"
                  x-small
                  @click="deleteImagem"
                >
                  <v-icon color="white" small> fa fa-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="dropbox">
                  <input
                    id="aviso.upload-imagem"
                    class="input-file"
                    type="file"
                    name="imagem"
                    accept="image/*"
                    @change="filesChange($event.target.files)"
                  />
                  <template v-if="temImagem">
                    <img v-if="previewImagem" class="dropbox__preview" :src="previewImagem" />
                    <p class="dropbox__texto">Imagem carregada! Clique para trocar.</p>
                  </template>
                  <p v-else class="dropbox__texto">
                    Arraste uma imagem aqui para começar<br />
                    ou clique para navegar
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="text-subtitle-1">Mensagem</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="título" rules="required|max:25" v-slot="{ errors }">
                      <v-text-field
                        id="form.titulo"
                        v-model="form.titulo"
                        :error-messages="errors"
                        label="Título"
                        counter="25"
                        maxlength="25"
                        outlined
                        dense
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="contexto" rules="required" v-slot="{ errors }">
                      <v-textarea
                        id="form.contexto"
                        v-model="form.contexto"
                        :error-messages="errors"
                        label="Contexto da mensagem"
                        rows="4"
                        outlined
                      ></v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="align-center">
          <v-col cols="12" sm="auto">
            <v-checkbox
              id="form.status"
              v-model="status"
              :false-value="1"
              :true-value="0"
              :label="situacaoLabel"
              color="success"
              class="mt-0 pt-0"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="auto">
            <v-btn
              id="aviso.submit"
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
            >
              Enviar Dados
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
const STATUS_ENVIADO = 2;

// Mesmos valores usados no controller: mudar aqui exige mudar lá.
const TIPOS = ["Turmas", "Escolas", "Alunos"];

const CARREGADORES = {
  Turmas: (services) => services.turmasService.syncAll(),
  Escolas: (services) => services.avisosService.franquias(),
  Alunos: (services) => services.avisosService.alunosFranquia(),
};

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selects: TIPOS,
      selectAll: false,
      avisoUpload: null,
      previewImagem: "",
      items: [],
      submittingForm: false,
      status: 0,
      form: {
        titulo: "",
        contexto: "",
        items: [],
        selected: "",
        imagem: null,
        status: 0,
      },
      situacoes: {
        0: { descricao: "Ativo", color: "blue lighten-1" },
        1: { descricao: "Inativo", color: "red lighten-1" },
        2: { descricao: "Enviado", color: "green lighten-1" },
      },
    };
  },
  computed: {
    avisoId() {
      return parseInt(this.$route.params.aviso_id, 10);
    },
    selected() {
      return this.form.selected;
    },
    temImagem() {
      return Boolean(this.avisoUpload || this.form.imagem);
    },
    situacaoLabel() {
      const situacao = this.situacoes[this.form.status || this.status];
      return situacao ? situacao.descricao : "- - -";
    },
  },

  watch: {
    selected(tipo) {
      if (!this.editing) {
        this.form.items = [];
        this.selectAll = false;
      }
      this.carregarItems(tipo);
    },

    selectAll(marcado) {
      this.form.items = marcado ? this.items.map((item) => item.id) : [];
    },
  },

  methods: {
    iniciais(item, tamanho) {
      return item.descricao ? item.descricao.substring(0, tamanho).toUpperCase() : "- - -";
    },

    remove(item) {
      const index = this.form.items.indexOf(item.id);
      if (index >= 0) this.form.items.splice(index, 1);
    },

    filesChange(fileList) {
      const [arquivo] = fileList;
      if (!arquivo) return;

      this.descartarPreview();
      this.avisoUpload = arquivo;
      this.previewImagem = URL.createObjectURL(arquivo);
    },

    deleteImagem() {
      this.descartarPreview();
      this.avisoUpload = null;
      this.form.imagem = null;
      this.previewImagem = "";
    },

    descartarPreview() {
      if (this.previewImagem.startsWith("blob:")) {
        URL.revokeObjectURL(this.previewImagem);
      }
    },

    async carregarItems(tipo) {
      const carregar = CARREGADORES[tipo];
      if (!carregar) {
        this.items = [];
        return;
      }

      this.$loaderService.open("Carregando dados...");
      try {
        this.items = await carregar(this.$services);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async loadData() {
      if (!this.editing) return;

      this.$loaderService.open("Carregando dados...");
      try {
        const response = await this.$services.avisosService.find(this.avisoId);

        this.form = { ...response, selected: response.tipo };
        this.status = parseInt(response.status, 10);

        if (this.form.imagem) {
          await this.carregarPreview();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async carregarPreview() {
      try {
        this.previewImagem = await this.$services.imageService.downloadImage(
          `notifiq/avisos/download-image/${this.avisoId}`
        );
      } catch (error) {
        this.previewImagem = "";
      }
    },

    async uploadImage(avisoId) {
      try {
        await this.$services.imageService.uploadImage(
          "notifiq/avisos/upload-image",
          this.avisoUpload,
          avisoId
        );
      } catch (error) {
        this.$handleError(error);
      }
    },

    async submitForm() {
      this.submittingForm = true;
      this.$loaderService.open("Salvando aviso, aguarde...");
      try {
        this.form.status = this.form.status === STATUS_ENVIADO ? this.form.status : this.status;

        const aviso = this.editing
          ? await this.$services.avisosService.update(this.form, this.avisoId)
          : await this.$services.avisosService.store(this.form);

        if (this.avisoUpload) {
          await this.uploadImage(this.editing ? this.avisoId : aviso.id);
        }

        this.$toast.success(`Aviso ${this.editing ? "editado" : "criado"} com sucesso!`);
        this.$router.push({ name: "avisos.index" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.submittingForm = false;
    },
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    this.descartarPreview();
  },
};
</script>

<style lang="scss" scoped>
.dropbox {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 12px;
  border: 2px dashed #9e9e9e;
  border-radius: 4px;
  background: lightcyan;
  color: dimgray;
  cursor: pointer;

  &:hover {
    background: lightblue;
  }
}

.dropbox__texto {
  margin: 0;
  font-size: 1.1em;
  text-align: center;
}

.dropbox__preview {
  max-width: 100%;
  max-height: 160px;
  margin-bottom: 8px;
  object-fit: contain;
}

.input-file {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
